/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
import type { Simulation } from "./Simulation";
import {
  SimulationFromJSON,
  SimulationFromJSONTyped,
  SimulationToJSON,
  SimulationToJSONTyped,
} from "./Simulation";

/**
 *
 * @export
 * @interface Usage
 */
export interface Usage {
  /**
   *
   */
  readonly id?: number;
  /**
   *
   */
  readonly simulation?: Simulation;
  /**
   *
   */
  started?: Date | null;
  /**
   *
   */
  finished?: Date | null;
  /**
   *
   */
  totalTime?: number | null;
  /**
   *
   */
  readonly status?: string;
  /**
   *
   */
  readonly simulationType?: string;
  /**
   *
   */
  readonly userName?: string;
  /**
   *
   */
  readonly organisationUuid?: string;
}

/**
 * Check if a given object implements the Usage interface.
 */
export function instanceOfUsage(value: object): value is Usage {
  return true;
}

export function UsageFromJSON(json: any): Usage {
  return UsageFromJSONTyped(json, false);
}

export function UsageFromJSONTyped(json: any, ignoreDiscriminator: boolean): Usage {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"] == null ? undefined : json["id"],
    simulation: json["simulation"] == null ? undefined : SimulationFromJSON(json["simulation"]),
    started:
      json["started"] === undefined
        ? undefined
        : json["started"] === null
        ? null
        : parseDateTime(json["started"]),
    finished:
      json["finished"] === undefined
        ? undefined
        : json["finished"] === null
        ? null
        : parseDateTime(json["finished"]),
    totalTime:
      json["total_time"] === undefined
        ? undefined
        : json["total_time"] === null
        ? null
        : json["total_time"],
    status: json["status"] == null ? undefined : json["status"],
    simulationType: json["simulation_type"] == null ? undefined : json["simulation_type"],
    userName: json["user_name"] == null ? undefined : json["user_name"],
    organisationUuid: json["organisation_uuid"] == null ? undefined : json["organisation_uuid"],
  };
}

export function UsageToJSON(json: any): Usage {
  return UsageToJSONTyped(json, false);
}

export function UsageToJSONTyped(
  value?: Omit<
    Usage,
    "id" | "simulation" | "status" | "simulationType" | "userName" | "organisationUuid"
  > | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    started: value["started"] == null ? value["started"] : serializeDateTime(value["started"]),
    finished: value["finished"] == null ? value["finished"] : serializeDateTime(value["finished"]),
    total_time: value["totalTime"],
  };
}
